import React, { useCallback, useEffect, useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { keyframes } from "@mui/system";
import Layout from "../components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import { BusinessService } from "../services/business-service";
import { StoreService } from "../services/store-service";
import { AuthService } from "../services/auth-service";
import { getCategories, getPartners } from "../services/server-actions"; // ✅ وارد کردن getCategories
import Clarity from "@microsoft/clarity";
import { TenantAvailabilityState } from "../services/shared/service-proxies/service-proxies";
import {SubdomainTenantResolver} from "../services/tenant-manager";

const fadeIn = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

const SplashScreen: React.FC = () => {
  const navigate = useNavigate();
  //const businessService = useMemo(() => new BusinessService(), []);
  const businessService = new BusinessService();
  const fetchProfile = useCallback(async () => {
    let subdomainTenantResolver = new SubdomainTenantResolver();
    let tenantName = subdomainTenantResolver.resolve();

    Clarity.setTag("tenant", tenantName);

    //const tenantName = "Default";
    let authService = new AuthService("111");
    let TenantData = {};
    const tenant = StoreService.GetData("tenant-data");
    if (!tenant) {
      await authService.isTenantAvalabel(tenantName).then((tenantData) => {
        if (
          tenantData.state == TenantAvailabilityState.InActive ||
          tenantData.state == TenantAvailabilityState.NotFound
        ) {
          alert(
            "سالن در این زمان در دسترس نمی باشد، لطفا با مدیریت سالن تماس حاصل نمایید"
          );
          navigate("/");
        }
        StoreService.SetData("tenant-data", tenantData);
        TenantData = tenantData;
      });
    }

    debugger
    const profile = await businessService.getProfile(tenantName);
    const session = await authService.getCurrrentSession();
    StoreService.SetData("user-session", session);

    if (profile.logo) {
      await businessService
        .getFile(profile.logo, profile.accessKey)
        .then((result) => {
          profile.logo = "data:image/jpeg;base64," + result;
        })
        .catch((error) => {
          console.log(error);
        });
    }
    if (profile.background) {
      await businessService
        .getFile(profile.background, profile.accessKey)
        .then((result) => {
          profile.background = "data:image/jpeg;base64," + result;
        })
        .catch((error) => {
          console.log(error);
        });
    }
    if (profile.posterImage) {
      await businessService
        .getFile(profile.posterImage, profile.accessKey)
        .then((result) => {
          profile.posterImage = "data:image/jpeg;base64," + result;
        })
        .catch((error) => {
          console.log(error);
        });
    }

    StoreService.SetData("business-profile", profile);

    const user = StoreService.GetData("user");

    if (!user) {
      navigate("/mobile-verify", { state: { profile } });
      return;
    }
    Clarity.setTag("user", user.userId);

    authService = new AuthService(user.accessToken);

    const tokenTimeTicks = parseInt(
      StoreService.GetData("access-time") as string,
      10
    );
    const tokenTime = new Date(tokenTimeTicks);
    tokenTime.setSeconds(tokenTime.getSeconds() + user.expireInSeconds);

    const isExpired = tokenTime.getTime() < Date.now();

    if (isExpired) {
      await authService
        .getRefreshToken()
        .then((result) => {
          user.accessToken = result.accessToken;
          user.encryptedAccessToken = result.encryptedAccessToken;
          user.expireInSeconds = result.expireInSeconds;
          StoreService.SetData("user", user);
          StoreService.SetData("access-time", Date.now());
          navigate("/");
        })
        .catch((error) => {
          if (error.response?.status === 401) {
            navigate("/mobile-verify", { state: { profile } });
            return;
          }
        });
    }

    if (user) {
      const categories = StoreService.GetData("categories");
      if (!categories) {
        const fetchedCategories = await getCategories("");
        StoreService.SetData("categories", fetchedCategories);
      }
      const fetchedCategories = await getPartners();
    }

    navigate("/main");
  }, [businessService, navigate]);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  return (
<Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100dvh", // ✅ به‌جای 100vh
    backgroundColor: "#695CD5",
    color: "white",
    fontSize: "2rem",
    borderRadius: 0,
    overflow: "hidden",
    boxSizing: "border-box",
  }}
>

      <Typography
        sx={{
          fontSize: { xs: "1.2rem", sm: "clamp(1.5rem, 5vw, 2rem)" },
          animation: `${fadeIn} 1.5s ease-in-out`,
          textAlign: "center",
        }}
      >
        Welcome to My App
      </Typography>
    </Box>
  );
};

export default SplashScreen;
